/**
 * http://coursesweb.net/javascript/convert-bbcode-html-javascript_cs
 * */

const BBCodeHTML = function() {
  const token_match = /{[A-Z_]+[0-9]*}/ig;

  // regular expressions for the different bbcode tokens
  const tokens = {
    'URL'        : '((?:(?:[a-z][a-z\\d+\\-.]*:\\/{2}(?:(?:[a-z0-9\\-._~\\!$&\'*+,;=:@|]+|%[\\dA-F]{2})+|[0-9.]+|\\[[a-z0-9.]+:[a-z0-9.]+:[a-z0-9.:]+\\])(?::\\d*)?(?:\\/(?:[a-z0-9\\-._~\\!$&\'*+,;=:@|]+|%[\\dA-F]{2})*)*(?:\\?(?:[a-z0-9\\-._~\\!$&\'*+,;=:@\\/?|]+|%[\\dA-F]{2})*)?(?:#(?:[a-z0-9\\-._~\\!$&\'*+,;=:@\\/?|]+|%[\\dA-F]{2})*)?)|(?:www\\.(?:[a-z0-9\\-._~\\!$&\'*+,;=:@|]+|%[\\dA-F]{2})+(?::\\d*)?(?:\\/(?:[a-z0-9\\-._~\\!$&\'*+,;=:@|]+|%[\\dA-F]{2})*)*(?:\\?(?:[a-z0-9\\-._~\\!$&\'*+,;=:@\\/?|]+|%[\\dA-F]{2})*)?(?:#(?:[a-z0-9\\-._~\\!$&\'*+,;=:@\\/?|]+|%[\\dA-F]{2})*)?)))',
    'LINK'       : '([a-z0-9\-\./]+[^"\' ]*)',
    'EMAIL'      : '((?:[\\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*(?:[\\w\!\#$\%\'\*\+\-\/\=\?\^\`{\|\}\~]|&)+@(?:(?:(?:(?:(?:[a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(?:\\d{1,3}\.){3}\\d{1,3}(?:\:\\d{1,5})?))',
    'TEXT'       : '(.*?)',
    'SIMPLETEXT' : '([a-zA-Z0-9-+.,_ ]+)',
    'INTTEXT'    : '([a-zA-Z0-9-+,_. ]+)',
    'IDENTIFIER' : '([a-zA-Z0-9-_]+)',
    'COLOR'      : '([a-z]+|#[0-9abcdef]+)',
    'NUMBER'     : '([0-9]+)',
  };

  const bbcode_matches = []; // matches for bbcode to html

  const html_tpls = []; // html templates for html to bbcode

  const html_matches = []; // matches for html to bbcode

  const bbcode_tpls = []; // bbcode templates for bbcode to html

  /**
   * Quote regular expression characters plus an optional character
   * taken from phpjs.org
   */
  function preg_quote (str, delimiter) {
    return String(str).replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
  }

  /**
   * Turns a bbcode into a regular rexpression by changing the tokens into
   * their regex form
   */
  const _getRegEx = function(str) {
    const matches = str.match(token_match);
    const nrmatches = matches.length;
    let i = 0;
    let replacement = '';

    if (nrmatches <= 0) {
      return new RegExp(preg_quote(str), 'g'); // no tokens so return the escaped string
    }

    for (; i < nrmatches; i += 1) {
      // Remove {, } and numbers from the token so it can match the
      // keys in tokens
      const token = matches[i].replace(/[{}0-9]/g, '');

      if (tokens[token]) {
        // Escape everything before the token
        replacement += preg_quote(str.substr(0, str.indexOf(matches[i]))) + tokens[token];

        // Remove everything before the end of the token so it can be used
        // with the next token. Doing this so that parts can be escaped
        str = str.substr(str.indexOf(matches[i]) + matches[i].length);
      }
    }

    replacement += preg_quote(str); // add whatever is left to the string

    return new RegExp(replacement, 'gi');
  };

  /**
   * Turns a bbcode template into the replacement form used in regular expressions
   * by turning the tokens in $1, $2, etc.
   */
  const _getTpls = function(str) {
    const matches = str.match(token_match);
    const nrmatches = matches.length;
    let i = 0;
    let replacement = '';
    const positions = {};
    let next_position = 0;

    if (nrmatches <= 0) {
      return str; // no tokens so return the string
    }

    for (; i < nrmatches; i += 1) {
      // Remove {, } and numbers from the token so it can match the
      // keys in tokens
      const token = matches[i].replace(/[{}0-9]/g, '');
      let position;

      // figure out what $# to use ($1, $2)
      if (positions[matches[i]]) {
        position = positions[matches[i]]; // if the token already has a position then use that
      }
      else {
        // token doesn't have a position so increment the next position
        // and record this token's position
        next_position += 1;
        position = next_position;
        positions[matches[i]] = position;
      }

      if (tokens[token]) {
        replacement += str.substr(0, str.indexOf(matches[i])) + '$' + position;
        str = str.substr(str.indexOf(matches[i]) + matches[i].length);
      }
    }

    replacement += str;

    return replacement;
  };

  /**
   * Adds a bbcode to the list
   */
  const addBBCode = function(bbcode_match, bbcode_tpl) {
    // add the regular expressions and templates for bbcode to html
    bbcode_matches.push(_getRegEx(bbcode_match));
    html_tpls.push(_getTpls(bbcode_tpl));

    // add the regular expressions and templates for html to bbcode
    html_matches.push(_getRegEx(bbcode_tpl));
    bbcode_tpls.push(_getTpls(bbcode_match));
  };

  /**
   * Turns all of the added bbcodes into html
   */
  const bbcodeToHtml = (str = '') => {
    const nrbbcmatches = bbcode_matches.length;
    let i = 0;

    if (str) {
      for (; i < nrbbcmatches; i += 1) {
        str = str.replace(bbcode_matches[i], html_tpls[i]);
      }
    }

    return str;
  };

  /**
   * Turns html into bbcode
   */
  // const htmlToBBCode = function(str) {
  //   const nrhtmlmatches = html_matches.length;
  //   let i = 0;

  //   for (; i < nrhtmlmatches; i += 1) {
  //     str = str.replace(html_matches[i], bbcode_tpls[i]);
  //   }

  //   return str;
  // };

  // adds BBCodes and their HTML
  addBBCode('[b]{TEXT}[/b]', '<strong>{TEXT}</strong>');
  addBBCode('[i]{TEXT}[/i]', '<em>{TEXT}</em>');
  addBBCode('[u]{TEXT}[/u]', '<span style="text-decoration:underline;">{TEXT}</span>');
  addBBCode('[s]{TEXT}[/s]', '<span style="text-decoration:line-through;">{TEXT}</span>');
  addBBCode('[url={URL}]{TEXT}[/url]', '<a href="{URL}" title="link" target="_blank">{TEXT}</a>');
  addBBCode('[url]{URL}[/url]', '<a href="{URL}" title="link" target="_blank">{URL}</a>');
  addBBCode('[url={LINK}]{TEXT}[/url]', '<a href="{LINK}" title="link" target="_blank">{TEXT}</a>');
  addBBCode('[url]{LINK}[/url]', '<a href="{LINK}" title="link" target="_blank">{LINK}</a>');
  addBBCode('[img={URL} width={NUMBER1} height={NUMBER2}]{TEXT}[/img]', '<img src="{URL}" width="{NUMBER1}" height="{NUMBER2}" alt="{TEXT}" />');
  addBBCode('[img]{URL}[/img]', '<img src="{URL}" alt="{URL}" style="width:100%"/>');
  addBBCode('[img={LINK} width={NUMBER1} height={NUMBER2}]{TEXT}[/img]', '<img src="{LINK}" width="{NUMBER1}" height="{NUMBER2}" alt="{TEXT}" />');
  addBBCode('[img]{LINK}[/img]', '<img src="{LINK}" alt="{LINK}" />');
  addBBCode('[color=COLOR]{TEXT}[/color]', '<span style="{COLOR}">{TEXT}</span>');
  addBBCode('[highlight={COLOR}]{TEXT}[/highlight]', '<span style="background-color:{COLOR}">{TEXT}</span>');
  addBBCode('[quote="{TEXT1}"]{TEXT2}[/quote]', '<div class="quote"><cite>{TEXT1}</cite><p>{TEXT2}</p></div>');
  addBBCode('[quote]{TEXT}[/quote]', '<cite>{TEXT}</cite>');
  addBBCode('[blockquote]{TEXT}[/blockquote]', '<blockquote>{TEXT}</blockquote>');
  addBBCode('[p]{TEXT}[/p]', '<p>{TEXT}</p>');
  addBBCode('[center]{TEXT}[/center]', '<div style="text-align:center">{TEXT}</div>');
  addBBCode('[left]{TEXT}[/left]', '<div style="text-align:left">{TEXT}</div>');
  addBBCode('[right]{TEXT}[/right]', '<div style="text-align:right">{TEXT}</div>');
  addBBCode('[small]{TEXT}[/small]', '<span style="font-size: 0.8em">{TEXT}</span>');
  addBBCode('[title1]{TEXT}[/title1]', '<h1>{TEXT}</h1>');
  addBBCode('[title2]{TEXT}[/title2]', '<h2>{TEXT}</h2>');
  addBBCode('[title3]{TEXT}[/title3]', '<h3>{TEXT}</h3>');
  addBBCode('[title4]{TEXT}[/title4]', '<h4>{TEXT}</h4>');
  addBBCode('[medium]{TEXT}[/medium]', '<span style="font-size:1.1em">{TEXT}</span>');
  addBBCode('[big]{TEXT}[/big]', '<span style="font-size:1.4em">{TEXT}</span>');
  addBBCode('[large]{TEXT}[/large]', '<span style="font-size:1.6em; line-height: 1.2em;">{TEXT}</span>');
  addBBCode('[huge]{TEXT}[/huge]', '<span style="font-size:1.8em; line-height: 1.2em;">{TEXT}</span>');
  addBBCode('[divider]{TEXT}[/divider]', '<div class="divider-title">{TEXT}</div>');

  return bbcodeToHtml;
};

// Strings with BBCode, and HTML code for test
// const str_bb = '[b]Bold[/b], [i][u]Oblique with Underline[/u][/i] , an internal link: [url]/javascript/getelementbyid[/url], and image:  [img=http://coursesweb.net/imgs/webcourses.gif width=191 height=63]CoursesWeb.net[/img]';
// const str_html = '<strong>Bold</strong>, <em><span style="text-decoration:underline;">Oblique with Underline</span></em>, image: <img src="http://coursesweb.net/imgs/webcourses.gif" width="191" height="63" alt="CoursesWeb.net" /> and a link: <a href="http://coursesweb.net/javascript/" title="link" target="_blank">coursesweb.net/</a>';

// convert the strings
// const get_html = bbcodeParser.bbcodeToHtml(str_bb);
// const get_bbcode = bbcodeParser.htmlToBBCode(str_html);

// export const bbcodeParser = BBCodeHTML();
// window.bbCode = bbcodeParser;
const bbCode = BBCodeHTML();

export default bbCode;



// WEBPACK FOOTER //
// ./src/global/buildLang.js